
if($(".lang-switch").length > 0){
    $(".lang-switch a").click(function(e){
        e.preventDefault();

        $(".lang-switch a").removeClass("active");
        $(this).addClass("active");
    });
}